<!-- header 全局顶部 -->
<template>
    <div class="e-header"
         ref="e-header"
         :style="{ width: setWidth() }">
        <div class="header-left">
            <img v-if="logo"
                 :src="logo" />
            <div class="text">
                <h3 ref="mycolor">{{ frontName }}</h3>
            </div>
        </div>
        <div class="header-center"
             ref="headerCenter">
            <el-menu v-if="!hiddenMenu"
                     :key="timestamp"
                     :default-active="menuActive"
                     class="el-menu-demo"
                     router
                     mode="horizontal"
                     text-color="#fff"
                     active-text-color="#FBC02D"
                     background-color="#0d81e0">
                <el-menu-item v-for="(item, index) in headerList"
                              :key="index"
                              :index="item.redirectAddress"
                              @click="handleSelect(item)">
                    {{ item.privilegeName }}
                </el-menu-item>
                <el-submenu index="/more"
                            class="more"
                            style="display: none">
                    <template slot="title">更多</template>
                    <el-menu-item :index="item.redirectAddress"
                                  @click="handleSelect(item)"
                                  v-for="item in overFlowData"
                                  :key="item.redirectAddress">
                        {{ item.name }}
                    </el-menu-item>
                </el-submenu>
            </el-menu>
        </div>
        <div class="header-right">
            <div v-if="!hiddenMsgBtn"
                 class="photo"
                 :class="[true ? 'activeMge' : '']"
                 @click="toMessage">
                <i class="iconfont iconxiaoxiicon-24"></i>
            </div>
            <p v-if="!hiddenRoleBtn"
               @click="changeRole">切换角色</p>
            <div class="sign-out">
                <el-dropdown trigger="click"
                             :hide-on-click="true">
                    <div class="text">
                        <img v-handleImgTX="loginInfoMessage.headPortraitPath" />
                        <p v-if="!hiddenRoleBtn">
                            {{ (loginInfoMessage && loginInfoMessage.userName) || '管理员' }}</p>
                        <p v-else>{{ loginInfoMessage && loginInfoMessage.userName }}</p>
                        <i class="el-icon-caret-bottom"></i>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-if="!hiddenSystem && systemAuthUrl"
                                          @click.native="toSystem">
                            <i class="el-icon-setting"
                               style="margin-right: 10px"></i>
                            系统管理
                        </el-dropdown-item>
                        <!-- <el-dropdown-item @click.native="alter">
                            <i class="el-icon-edit"
                               style="margin-right:10px"></i>修改密码</el-dropdown-item> -->
                        <el-dropdown-item @click.native="jumpLogin">
                            <i class="el-icon-sold-out"
                               style="margin-right: 10px"></i>
                            退出登录
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <ht-dialog :dialogVisible.sync="dialogVisible"
                   :title="title"
                   :cancel="cancel"
                   :affirm="affirm"
                   @boxAffirm="boxAffirm"
                   @boxCancel="boxCancel">
            <alter-password v-if="dialogShow === 'password'"
                            @close="dialogVisible = false"></alter-password>
            <alter-role v-if="dialogShow === 'role'"
                        :cutList="cutList"
                        ref="alter-role"></alter-role>
        </ht-dialog>
        <ht-dialog :dialogVisible.sync="dialogVisible2"
                   title="友情提示"
                   width="5rem"
                   boxExceptPd
                   :affirm="'知道了'"
                   @boxHandleClose="HandleClose"
                   @boxAffirm="HandleClose">
            <div style="padding: 0.44rem 0.24rem; line-height: 1.2">
                <i class="iconfont iconjingshiicon-"
                   style="font-size: 0.25rem; margin-right: 0.1rem; color: #b7965e"></i>
                没有权限！请联系管理员。
            </div>
        </ht-dialog>
        <ht-loading :loading="loading"
                    :name="'loading'"></ht-loading>
    </div>
</template>
<script>
import Cookie from 'common/js/cookie'
import htLoading from 'base/ht-loading'
import htDialog from 'base/ht-dialog'
import { loginInfo } from 'common/js/util.js'
import { commonality } from '@/util/commonality'
import alterPassword from 'components/main/alter-password' // 修改密码
import alterRole from 'components/main/alter-role' // 切换角色
import { mapGetters, mapActions } from 'vuex'
export default {
    components: { htDialog, alterPassword, alterRole, htLoading },
    mixins: [commonality],
    data () {
        return {
            navBar: [],
            controlIcon: ['iconshishizhuangtaijiankongicon-24', 'iconzhouzhuangtaijiankongicon-24', 'iconxueqizhuangtaijiankongicon-24'],
            analyseIcon: ['iconjiaoxuegaikuang-daohang-24', 'icondankechengfenxi-daohang-24', 'iconduokechengduibi-daohang-24', 'iconziwozhengai-daohang-24'],
            loading: false,
            affirm: '',
            cancel: '',
            dialogShow: '', // 弹窗类型区分
            dialogVisible: false,
            dialogVisible2: false,
            title: '',
            judgeBox: true,
            pathList: [
                {
                    path: '/index',
                    name: '监控',
                    type: 'control',
                    menuCode: 'MONITOR'
                },
                {
                    path: '/supervising',
                    name: '分析',
                    type: 'supervising',
                    // headerWidth: '13.6rem',
                    menuCode: 'ANALYSIS'
                },
                {
                    path: '/resource',
                    name: '资源',
                    type: 'resource',
                    headerWidth: '13.6rem',
                    menuCode: 'RESOURSE'
                },
                {
                    path: '/use/home',
                    name: '应用',
                    type: 'use',
                    headerWidth: '13.6rem',
                    menuCode: 'APP'
                },
                {
                    path: '/index/analyse',
                    name: '教学分析',
                    type: 'analyse',
                    menuCode: 'TEACHING_ANALYSIS'
                },
                {
                    path: '/center/home',
                    name: '个人中心',
                    type: 'center',
                    headerWidth: '13.6rem',
                    menuCode: 'PERSONAL'
                }
            ],
            headerList: [], // header 数组
            identity: '', // 身份类别
            overFlowData: [], // 更多-隐藏的数组
            minVal: 0,
            loginInfoMessage: {
                userType: ''
            },
            locationHref: '',
            cutList: [],
            systemAuthUrl: '', // 后台管理地址
            timestamp: '0'
        }
    },
    computed: {
        ...mapGetters(['commonality', 'getSystemInfo']),
        frontName () {
            return this.getSystemInfo.FRONT_NAME
        },
        logo () {
            return this.getSystemInfo.SQUARE_TINT_COLOR_LOGO
        },
        params () {
            var param = loginInfo()
            return {
                userCode: param.userCode,
                operatorId: param.operatorId,
                identity: this.commonality.identity || undefined
            }
        },
        menuActive () {
            var type = this.headerList.filter(r => this.$route.path.includes(r.type))[0]
            return type ? type.redirectAddress : this.$route.path
        }
    },
    watch: {
        $route (to, from) {
            if (to.path === '/supervising') {
                if (this.commonality.supervisingMenu) {
                    this.set_commonality({ asideMenu: this.commonality.supervisingMenu })
                } else {
                    this.getMenu(true)
                }
            } else if (to.path === '/index') {
                if (this.commonality.controlMenu) {
                    this.set_commonality({ asideMenu: this.commonality.controlMenu })
                    this.set_commonality({ controlKey: this.commonality.asideMenu[0].redirectAddress })
                    if (this.commonality.asideMenu[0].children) {
                        this.$router.replace({ path: this.commonality.asideMenu[0].children[0].redirectAddress })
                    }
                } else {
                    this.getMenu(true)
                }
            } else if (to.path === '/index/analyse') {
                if (this.commonality.analysisMenu) {
                    this.set_commonality({ asideMenu: this.commonality.analysisMenu })
                    if (this.commonality.asideMenu[0].children) {
                        this.$router.replace({ path: this.commonality.asideMenu[0].redirectAddress })
                    }
                } else {
                    this.getMenu(true)
                }
            }
            if (this.locationHref) {
                this.$listen('popstate', this.backCommon, 'remove') // 解除浏览器回退
                this.locationHref = ''
            }
            var obj = this.pathList.filter(r => r.path === to.path)[0]
            if (obj) {
                this.set_commonality({
                    pathName: obj
                })
            } // 避免嵌套的iframe无法隐藏 、保存模块信息
        },
        headerList (val) {
            if (this.$refs.headerCenter) this.$refs.headerCenter.style.opacity = 0
            setTimeout(() => {
                this.adopt(true)
            }, 300)
        }
    },
    created () {
        this.getuserInfoMessage() // 获取个人信息
    },
    mounted () {
        var _this = this
        _this.$listen('resize', _this.adopt, 'add', 'init')
        // conosle.log(this.this.$refs.mycolor.style.setProperty("--bcColor",'white'))
    },
    destroyed () {
        this.$listen('resize', this.adopt, 'remove')
    },
    methods: {
        ...mapActions([
            'set_commonality' // 路由  数据接口
        ]),
        // 获取分析菜单
        getMenu (judge) {
            let userInfo = {}
            const _this = this
            userInfo.operatorId = loginInfo().operatorId
            userInfo.userCode = loginInfo().userCode
            userInfo.clientCategory = window.clientCategory
            userInfo.systemCode = this.identity === 'SUPERVISOR_OR_LEADER_PC' || this.identity === 'SECRETARY_PC' ? 'MONITOR' : 'TEACHING_ANALYSIS'
            userInfo.levelNumber = 1
            userInfo.controlType = 'MENU'
            if (this.$route.path === '/supervising') {
                this.$api.GET_TREEPOINTSYSTEMPRIVILEGE(userInfo).then(res => {
                    if (res.code === '40001') {
                        res.content.list.map(item => {
                            item.children.map(child => {
                                child.redirectAddress = this.getPointPath(child)
                            })
                        })
                        this.navBar = res.content.list
                        this.navBar.unshift({
                            privilegeName: '数据分析中心',
                            redirectAddress: '/supervising',
                            iconClass: 'iconjiaoxuegaikuang-daohang-24',
                            children: []
                        })
                        this.navBar.map(item => {
                            item.iconClass = 'iconjiaoxuegaikuang-daohang-24'
                        })
                        this.set_commonality({ supervisingMenu: _this.navBar })
                        this.set_commonality({ asideMenu: _this.navBar })
                    }
                })
            }
            // if (this.$route.path === '/index') {
            //     let indexMenuArr = this.headerList.filter(item => { return item.type === 'index' })
            //     if (indexMenuArr && indexMenuArr.length) {
            //         if (this.$route.path !== indexMenuArr[0].children[0].children[0].redirectAddress) {
            //             this.$router.replace(indexMenuArr[0].children[0].children[0].redirectAddress)
            //         }
            //         var Obj = this.headerList.filter(r => this.$route.path.includes(r.type))
            //         if (Obj.length > 0) this.set_commonality({ pathName: Obj[0] })
            //         // 设置图标
            //         indexMenuArr[0].children.map((item, index) => {
            //             item.iconClass = (this.identity === 'SUPERVISOR_OR_LEADER_PC' || this.identity === 'SECRETARY_PC') ? this.controlIcon[index] : this.analyseIcon[index]
            //         })
            //         this.set_commonality({ controlMenu: indexMenuArr[0].children })
            //         this.set_commonality({ asideMenu: indexMenuArr[0].children })
            //     }
            // } else if (this.$route.path === '/supervising') {
            //     this.$api.GET_TREEPOINTSYSTEMPRIVILEGE(userInfo).then(res => {
            //         if (res.code === '40001') {
            //             res.content.list.map((item) => {
            //                 item.children.map(child => {
            //                     child.redirectAddress = this.getPointPath(child)
            //                 })
            //             })
            //             this.navBar = res.content.list
            //             this.navBar.unshift({
            //                 privilegeName: '数据分析中心',
            //                 redirectAddress: '/supervising',
            //                 iconClass: 'iconjiaoxuegaikuang-daohang-24',
            //                 children: []
            //             })
            //             this.navBar.map(item => {
            //                 item.iconClass = 'iconjiaoxuegaikuang-daohang-24'
            //             })
            //             this.set_commonality({ supervisingMenu: _this.navBar })
            //             this.set_commonality({ asideMenu: _this.navBar })
            //         }
            //     })
            // } else if (this.$route.path === '/index/analyse') {
            //     this.$api.treeMemoSystemPrivilegeByUserCode(userInfo).then(res => {
            //         res.content.list.map((item) => {
            //             item.children.map(child => {
            //                 child.redirectAddress = this.getPointPath(child)
            //             })
            //         })
            //         this.navBar = res.content.list
            //         this.navBar.map(item => {
            //             item.iconClass = 'iconjiaoxuegaikuang-daohang-24'
            //         })
            //         this.set_commonality({ analysisMenu: _this.navBar })
            //         this.set_commonality({ asideMenu: _this.navBar })
            //         if (this.$route.path !== this.navBar[0].redirectAddress) {
            //             this.$router.push({ path: this.navBar[0].redirectAddress })
            //         }
            //     })
            // } else if (this.$route.path === '/use/home') {
            //     let indexMenuArr = this.headerList.filter(item => { return item.type === 'use' })
            //     if (indexMenuArr && indexMenuArr.length) {
            //         if (this.$route.path !== indexMenuArr[0].children[0].children[0].redirectAddress) {
            //             this.$router.replace(indexMenuArr[0].children[0].children[0].redirectAddress)
            //         }
            //         var Obj = this.headerList.filter(r => this.$route.path.includes(r.type))
            //         if (Obj.length > 0) this.set_commonality({ pathName: Obj[0] })
            //         this.set_commonality({ useMenu: indexMenuArr[0].children })
            //     }
            // }
        },
        getuserInfoMessage () { // 获取个人信息
            if (this.params.userCode) {
                this.$api.userMsg(this.params).then(res => {
                    this.loginInfoMessage = res.content.pcTeacherInfoVo || {}
                    this.set_commonality({ atUserInfo: this.loginInfoMessage })
                    if (this.loginInfoMessage.userType === 'TEACHER') {
                        this.getRole() // 教师初始获取角色
                        this.getSystemAuth()
                    } else {
                        // 学生身份获取菜单
                        this.identity = 'STUDENT_PC'
                        this.getHeaderMenu()
                    }
                })
            } else {
                this.$api.GET_AUTHUSER_INFO().then(res => {
                    this.loginInfoMessage = res.content
                    this.set_commonality({ atUserInfo: res.content })
                    let obj = sessionStorage.getItem('loginInfo') ? JSON.parse(sessionStorage.getItem('loginInfo')) : {}
                    sessionStorage.setItem('loginInfo', JSON.stringify({ ...obj, ...res.content }))
                    if (this.loginInfoMessage.userType === 'TEACHER') {
                        this.getRole() // 教师初始获取角色
                        this.getSystemAuth()
                    } else {
                        // 学生身份获取菜单
                        this.identity = 'STUDENT_PC'
                        this.getHeaderMenu()
                    }
                })
            }
        },
        // 获取用户角色
        getRole (judge) {
            let authRes = this.$route.query.authRes
            this.$api.teacherOrStudent(this.params).then(res => {
                var defaultIdentityArr = res.content.list.filter(r => r.defaultIdentity === 'YES') || []
                if (authRes && !judge && (authRes === 'COUNCILOR' || authRes === 'TEACHER' || authRes === 'SECRETARY')) {
                    // 认证跳转身份
                    if (authRes === 'COUNCILOR') {
                        let arr = res.content.list.filter(r => r.identity === 'SUPERVISOR_OR_LEADER_PC')
                        defaultIdentityArr = arr || []
                    } else if (authRes === 'SECRETARY') {
                        // 秘书
                        let arr = res.content.list.filter(r => r.identity === 'SECRETARY_PC')
                        defaultIdentityArr = arr || []
                    } else if (authRes === 'TEACHER') {
                        let arr = res.content.list.filter(r => r.identity === 'TEACHER_PC')
                        defaultIdentityArr = arr || []
                    } else {
                        defaultIdentityArr = []
                    }
                }
                if (defaultIdentityArr.length === 0) {
                    this.dialogVisible2 = true
                    return false
                }
                this.identity = (defaultIdentityArr[0] && defaultIdentityArr[0].identity) || ''
                this.set_commonality({ identity: (defaultIdentityArr[0] && defaultIdentityArr[0].identity) || '' })
                this.set_commonality({ identityObj: defaultIdentityArr[0] || {} }) // 由于接口变化 所以新增存储参数
                this.cutList = res.content.list
                this.set_commonality({ headerList: this.cutList })
                // this.headerList = res.content.menuInfoList.map(r => {
                //     var Objval = this.pathList.filter(m => m.menuCode === r.menuCode)[0]
                //     r = Object.assign(r, Objval)
                //     return r
                // })
                this.getHeaderMenu()
                this.getMenu(judge) // 获取左侧菜单数据
                this.loading = false // 关闭loading
            })
        },
        // 获取header菜单
        getHeaderMenu () {
            if (this.hiddenMenu) {
                return
            }
            this.loading = true
            let params = {
                identitiesForMenus: this.identity,
                filter: 'YES'
            }
            this.$api.getApplicationTreeMenu(params).then(res => {
                this.timestamp = new Date().getTime()
                if (res.content.list && res.content.list.length) {
                    this.headerList = res.content.list[0].list
                    this.headerList.map(item => {
                        if (item.redirectAddress) {
                            item.type = item.redirectAddress.split('/')[1]
                            if (item.redirectAddress === '/index/analyse/home') {
                                item.type = '/index/analyse'
                            }
                        }
                        if (['/use/home', '/center/home', '/dataExportCenter/HIS_DATA_EXPORT_CENTRE'].includes(item.redirectAddress)) {
                            item.headerWidth = '13.6rem'
                        }
                        if (item.redirectAddress === '/index') {
                            this.set_commonality({ controlMenu: item.children })
                        } else if (item.redirectAddress === '/use/home') {
                            // item.children[0].children.push({
                            //     "privilegeCode": "20240722000605",
                            //     "privilegeName": "教师自评",
                            //     "children": [],
                            //     "redirectAddress": "/use/allcontent/evaluateSelf",
                            //     "addressType": "ROUTE",
                            //     "isSelective": "YES",
                            //     "privilegeType": "SYSTEM_DEFAULT",
                            //     "iconPath": null
                            // })
                            this.set_commonality({ useMenu: item.children })
                        } else if (item.redirectAddress === '/index/analyse') {
                            this.set_commonality({ analysisMenu: item.children })
                        }
                    })
                    this.loading = false
                } else {
                    this.headerList = []
                    this.loading = false
                }
            })
        },
        adopt (judge) {
            if (this.hiddenMenu) {
                return
            }
            // 监听窗口 控制头部模块显示
            setTimeout(() => {
                var _this = this
                let overArr = []
                let occupyArr = []
                let index = 0
                let min = 3
                // eslint-disable-next-line no-unused-vars
                let judge = ''
                let headerAllEvent = document.getElementsByClassName('e-header')[0]
                let headerLeftEvent = document.getElementsByClassName('header-left')[0]
                let headerRightEvent = document.getElementsByClassName('header-right')[0]
                let headerCenterEvent = document.getElementsByClassName('header-center')[0]
                if (!headerCenterEvent) return
                judge = _this.minVal
                let moreEvent = document.getElementsByClassName('more')[0]
                // judge 数组刷新不执行
                if (!judge && _this.minVal && _this.minVal <= headerCenterEvent.clientWidth) index = min
                if (!_this.minVal || headerCenterEvent.clientWidth < _this.minVal) {
                    _this.minVal = headerCenterEvent.clientWidth
                }
                let headerCenterWidth = headerAllEvent.clientWidth - headerLeftEvent.clientWidth - headerRightEvent.clientWidth
                let headerCenterLilists = headerCenterEvent.children[0].children
                function name () {
                    if (index >= min) return
                    let sum = 0
                    for (let i = 0; i < headerCenterLilists.length - 1; i++) {
                        sum += headerCenterLilists[i].clientWidth || 0
                        if (sum > headerCenterWidth / 2 - moreEvent.clientWidth || headerCenterLilists[i].clientWidth === 0) {
                            // headerCenterLilists[i].style.display = 'none'
                            headerCenterLilists[i].style.margin = 0
                            headerCenterLilists[i].style.width = 0
                            headerCenterLilists[i].style.padding = 0
                            headerCenterLilists[i].style.opacity = 0
                            overArr.push(_this.headerList[i])
                        } else {
                            if (headerCenterLilists[i].clientWidth) {
                                // headerCenterLilists[i].style.display = ''
                                headerCenterLilists[i].style.margin = ''
                                headerCenterLilists[i].style.width = ''
                                headerCenterLilists[i].style.padding = ''
                                headerCenterLilists[i].style.opacity = 1
                                occupyArr.push(_this.headerList[i])
                            }
                        }
                    }
                    _this.overFlowData = overArr
                    if (overArr.length > 0) {
                        moreEvent.style.display = ''
                    }
                    if (overArr.length === 0) {
                        name(index++)
                    }
                    if (_this.$refs.headerCenter) _this.$refs.headerCenter.style.opacity = 1
                }
                name()
                _this.timestamp = new Date().getTime()
            }, 300)
        },
        // 切换角色
        changeRole () {
            this.title = '切换角色'
            this.dialogShow = 'role'
            this.affirm = '确认'
            this.cancel = '取消'
            this.dialogVisible = true
        },
        HandleClose (val, callBack) {
            callBack && callBack()
            this.hitClear() // 清除记录
            // this.$router.replace('/login/sail')
        },
        boxAffirm (val, callBack) {
            // 确认
            callBack()
            var arr = this.$refs['alter-role'].menu
            var index = this.$refs['alter-role'].menuActive
            if (this.commonality.identity === arr[index].prop) return // 相同身份不切换
            this.loading = true
            this.set_commonality({ identity: arr[index].prop })
            this.set_commonality({ 'center-menu': 0 }) // 切换初始化到个人中心-个人信息
            // this.getRole(true) // 获取角色
            this.identity = arr[index].prop
            this.getHeaderMenu()
            setTimeout(() => {
                if (this.$route.path !== '/use/home') {
                    this.$router.replace('/use/home')
                    setTimeout(() => {
                        // 禁止浏览器后退
                        this.locationHref = document.location.href
                        this.$listen('popstate', this.backCommon, 'add', 'init')
                    }, 300)
                }
            }, 1000)
        },
        backCommon (url) {
            history.pushState(null, null, this.locationHref)
        },
        boxCancel (val, callBack) {
            // 取消
            callBack()
        },
        setWidth () {
            var wth = this.headerList.filter(r => this.$route.path.includes(r.type))
            // console.log(432, this.headerList, wth)
            var val = (wth.length > 0 && wth[0].headerWidth) || ''
            return val
        },
        handleSelect (item) {
            // if (item.type === '/supervising') {
            //     var _iframe = document.getElementById('supervising').contentWindow
            //     if (_iframe.document.getElementsByClassName('.tableFrame-title-btn')) _iframe.document.getElementsByClassName('.tableFrame-title-btn').click()
            // }
            // console.log(item)
            // _iframe.location.reload(true)
            this.set_commonality({ pathName: item })
        },
        jumpLogin () {
            let loginType = sessionStorage.getItem('loginInfo') ? JSON.parse(sessionStorage.getItem('loginInfo')).loginType : ''
            if (loginType === 'self') {
                this.hitClear()
                this.$router.push('/login/sail')
            } else if (loginType === 'teacherQuestionnaire') {
                Cookie.delCookie('contSum') // 登录解除-验证次数归零
                Cookie.delCookie('userInfo') // 登录解除-验证信息清除
                Cookie.delCookie('evaluate_front_login_access_token')
                this.set_commonality({}) // 最后执行避免header宽度全屏
                sessionStorage.removeItem('commonality')
                sessionStorage.removeItem('token')
                this.$router.push('/login/sail')
            } else {
                // STANDARD_CAS
                this.$api.outLogin({ token: loginInfo().token, platType: 'STANDARD_CAS' }).then(r => {
                    this.hitClear()
                    this.set_commonality({}) // 最后执行避免header宽度全屏
                    window.location.href = r.message // 重定向到cas登录页面
                })
            }
        },
        // 清除记录
        hitClear () {
            Cookie.delCookie('contSum') // 登录解除-验证次数归零
            Cookie.delCookie('userInfo') // 登录解除-验证信息清除
            Cookie.delCookie('evaluate_front_login_access_token')
            this.set_commonality({}) // 最后执行避免header宽度全屏
            sessionStorage.removeItem('commonality')
            sessionStorage.removeItem('loginInfo')
            sessionStorage.removeItem('token')
        },
        alter () {
            this.title = '修改密码'
            this.dialogShow = 'password'
            this.affirm = ''
            this.cancel = ''
            this.dialogVisible = true
        },
        // 获取分析点路径
        getPointPath (item) {
            let type = item.redirectAddress.split('_')
            let path = ''
            if (type[0] === 'DB') {
                path = `/supervising/scoreStatistics/${item.redirectAddress}`
            } else if (type[0] === 'TR') {
                path = `/supervising/reportStatistics/${item.redirectAddress}`
            } else if (type[0] === 'ZB') {
                path = `/supervising/indexanalysis/${item.redirectAddress}`
            } else if (type[0] === 'JD') {
                path = `/supervising/lessonProgress/${item.redirectAddress}`
            } else if (type[0] === 'JL') {
                path = `/supervising/lessonRecord/${item.redirectAddress}`
            } else if (type[0] === 'CPL') {
                path = `/supervising/stujoinprecent/${item.redirectAddress}`
            } else if (type[0] === 'XXJSDF') {
                path = `/supervising/messageteacherscore/${item.redirectAddress}`
            } else if (type[0] === 'XXKCDF') {
                path = `/supervising/messageclassscore/${item.redirectAddress}`
            } else if (type[0] === 'CS') {
                path = `/supervising/teaching/${item.redirectAddress}`
            } else if (type[0] === 'HZ') {
                path = `/supervising/scoresummary/${item.redirectAddress}`
            } else if (type[0] === 'HZTCSC') {
                path = `/supervising/tchCourseScore/${item.redirectAddress}`
            } else if (type[0] === 'YEAR') {
                path = `/supervising/scoresummary/${item.redirectAddress}`
            } else if (type[1] === 'COMPARE') {
                path = `/supervising/compareAnalysis/${item.redirectAddress}`
            } else if (type[1] === 'DIS') {
                path = `/supervising/scoreDistribute/${item.redirectAddress}`
            } else if (type[1] === 'VERDIS') {
                path = `/supervising/verticalAnalysis/${item.redirectAddress}`
            } else if (type[0] === 'ATD') {
                path = `/supervising/clockingIn/${item.redirectAddress}` // 考勤
            } else if (type[0] === 'TCH') {
                path = `/supervising/teacherAppreciable/${item.redirectAddress}` // 教师评学 - 参评率
            } else if (type[0] === 'COLLECT') {
                path = `/supervising/pooledAnalysis/${item.redirectAddress}` // 汇总分析（4条新增）
            } else if (type[0] === 'STU') {
                path = `/supervising/stuEvaluation/${item.redirectAddress}` // 学生评教（7条新增）
            } else if (type[0] === 'QUES') {
                path = `/supervising/questionnaire/${item.redirectAddress}`
            } else if (type[1] === 'GRADUATE') {
                path = `/supervising/questionnaire/${item.redirectAddress}`
            } else if (type[0] === 'TEACHINGRESOURCE') {
                path = `/supervising/teachResource/${item.redirectAddress}`
            } else if (type[0] === 'TEACHINGINTERACTION') {
                path = `/supervising/courseInteract/${item.redirectAddress}`
            } else if (type[0] === 'REPORT') {
                //教学评价质量分析
                path = `/supervising/qualityEvaluation/${item.redirectAddress}`
            } else if (type[0] === 'HIS') {
                //教学评价质量分析
                path = `/supervising/history/${item.redirectAddress}`
            } else if (type[0] === 'POINT') {
                if (item.redirectAddress === 'POINT_TCH_NOT_EVAL' || item.redirectAddress === 'POINT_COURSE_NOT_EVAL') {
                    path = `/supervising/evaluate/${item.redirectAddress}`
                }
                if (item.redirectAddress === 'POINT_TCH_YEAR_COMPARE_ANALYSIS' || item.redirectAddress === 'POINT_TCH_SCORE_REL_ANALYSIS') {
                    path = `/supervising/yearAnalysis/${item.redirectAddress}`
                }
                if (item.redirectAddress === 'POINT_STU_EVAL_EFFECTIVE_ANALYSIS' || item.redirectAddress === 'POINT_STU_EVAL_REL_ANALYSIS') {
                    //学生评价有效分析
                    path = `/supervising/studentEvaluate/${item.redirectAddress}`
                }
                if (item.redirectAddress === 'POINT_STU_EVAL_GRADE_ANALYSIS') {
                    //学生评价各年级打分
                    path = `/supervising/studentEvalGrade/${item.redirectAddress}`
                }
                if (item.redirectAddress === 'POINT_TCH_EVAL_SCORE_ABNORMAL_ANALYSIS' || item.redirectAddress === 'POINT_COURSE_EVAL_SCORE_ABNORMAL_ANALYSIS') {
                    //教师/课程评价得分异常
                    path = `/supervising/abnormal/${item.redirectAddress}`
                }
                if (
                    item.redirectAddress === 'POINT_SCH_QA_ANALYSIS_REPORT' ||
                    item.redirectAddress === 'POINT_ORG_QA_ANALYSIS_REPORT' ||
                    item.redirectAddress === 'POINT_TCH_QA_ANALYSIS_REPORT' ||
                    item.redirectAddress === 'POINT_DEP_COURSE_REPORT' ||
                    item.redirectAddress === 'POINT_SCH_QA_BRIEF_REPORT'
                ) {
                    //学校教学质量分析报告
                    path = `/supervising/analysisReport/${item.redirectAddress}`
                }
                if (
                    item.redirectAddress === 'POINT_ENT_EVAL_STU' ||
                    item.redirectAddress === 'POINT_STU_EVAL_ENT' ||
                    item.redirectAddress === 'POINT_TCH_EVAL_ENT'
                ) {
                    //实习评价
                    path = `/supervising/entEval/${item.redirectAddress}`
                }
                if (item.redirectAddress === 'POINT_STU_EVAL_INFO') {
                    //学生评教评分分布
                    path = `/supervising/verticalAnalysis/${item.redirectAddress}`
                }
                if (item.redirectAddress === 'POINT_STU_EVAL_KPI') {
                    //学生评教指标总览
                    path = `/supervising/stuEvalKpi/${item.redirectAddress}`
                }
                if (item.redirectAddress === 'POINT_STU_EVAL_LABLE') {
                    path = `/supervising/studentEvaLable/${item.redirectAddress}`
                }
            } else if (type[0] === 'HIGHWORDS') {
                path = `/supervising/${item.redirectAddress}`
            } else if (type[0] === 'WORKRECORD') {
                path = `/supervising/workRecordSummary/${item.redirectAddress}`
            } else if (item.redirectAddress === 'IMPROVED_REPORT') {
                path = `/supervising/tchImprovedReport`
            } else if (item.redirectAddress === 'SELF_EVALUATION_REPORT') {
                path = `/supervising/tchSelfEvaluationReport`
            }
            return path
        },
        // 获取后台管理权限
        getSystemAuth () {
            this.$api.GET_ROLE_ISMANAGER().then(res => {
                if (res.content === 'YES') {
                    // this.$api.GET_DEFAUTH_GETCASEADDRESS({ sysCode: "evaluatemanager" }).then(res => {
                    //     this.systemAuthUrl = `${res.content}network_backstage`
                    // })
                    this.systemAuthUrl = window.location.href.split('teachServicePort')[0] + '/evaluate/#/index'
                }
            })
        },
        // 跳转到后台管理页面
        toSystem () {
            window.open(this.systemAuthUrl)
        },
        // 跳转到消息页面
        toMessage () {
            this.$router.push({ path: '/center/home', query: { fixMessage: true } })
        }
    }
}
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
.e-header {
    width: 100%
    height: 100%
    font-size: 0
    display: flex
    margin: auto
    transition: width 0.3s ease 0s
    .header-center {
        width: calc(100% - 442px)
        text-align: center
        flex: 1
        .more {
            margin: 0
            padding: 0
            &.is-active {
                border-bottom: none
            }
            .el-submenu__title {
                padding: 0 0.08rem
                height: 100%
                border-width: 4px
                // border-bottom: 4px solid #ffffff;
                position: relative
                i {
                    color: #fff
                }
            }
        }
        .more.is-active {
            opacity: 1 !important
        }
        .is-active {
            color: #fff !important
            font-weight: bold
            opacity: 1
            font-size: 16px
            transition: opacity 0.1s
            border-width: 4px
            // border-bottom: 4px solid #ffffff !important;
            padding: 0 0.08rem
            >div.el-submenu__title {
                color: #fff !important
                border-width: 4px
                // border-bottom: 4px solid #ffffff !important;
                font-weight: bold
                padding: 0 0.08rem
            }
        }
        .el-menu.el-menu--horizontal {
            border-bottom: none !important
            height: 100%
        }
        ul {
            display: flex
            justify-content: center
            li {
                height: 64px
                font-size: 16px
                opacity: 0.7
                padding: 0 0.08rem
                margin: 0 0.3rem
                transition: all 0.1s
            }
        }
    }
    .header-left, .header-right {
        display: flex
        height: 100%
        padding: 21px 0
        box-sizing: border-box
        white-space: nowrap
    }
    .header-left {
        float: left
        align-items: center
        >img {
            width: 100%
            height: 32px
            max-height: 48px // 内江logo 36
            margin-right: 0.08rem
            -webkit-user-drag: none
            // pointer-events: none;
        }
        .text {
            display: inline
            user-select: none
            float: left
            // border-left: 1px solid rgba(77, 91, 136, 1);
            h3 {
                // font-size: $font-size-large;
                font-size: 20px
                // font-weight: 600;
                color: rgba(255, 255, 255, 1)
            }
        }
    }
    .header-right {
        display: flex
        align-items: center
        >p {
            font-size: 0.14rem
            color: #fff
            padding: 0 0.16rem
            border-left: 1px solid rgba(255, 255, 255, 0.2)
            border-right: 1px solid rgba(255, 255, 255, 0.2)
            margin: 0 0.18rem
            height: 0.25rem
            line-height: 0.25rem
            cursor: pointer
        }
        .activeMge:after {
            content: ''
            width: 0.06rem
            height: 0.06rem
            display: inline-block
            background-color: #fbc02d
            border-radius: 50%
            margin-left: 0.03rem
            position: absolute
            top: 0
            transition: 0.15s ease-in
            right: -0.05rem
        }
        .photo {
            position: relative
            i {
                color: #fff
                cursor: pointer
                font-size: 0.24rem
            }
            >img {
                width: 100%
                height: 100%
                border-radius: 50%
            }
        }
        .text {
            display: flex
            align-items: center
            cursor: pointer
            >img {
                width: 0.24rem
                height: 0.24rem
            }
            p {
                font-size: $font-size-medium
                color: #ffffff
                padding: 0 0.08rem
            }
        }
        .sign-out {
            float: left
            cursor: pointer
            .el-icon-caret-bottom {
                color: #fff
            }
        }
    }
    .loading {
        position: fixed
        top: 0
        right: 0
        bottom: 0
        left: 0
        overflow: auto
        margin: 0
        z-index: 2002
        font-size: 0.2rem
        overflow: hidden
        text-align: center
        .ht-dialog-shade {
            position: fixed
            left: 0
            top: 0
            width: 100%
            height: 100%
            opacity: 0.5
            background: #000
            z-index: 2001
        }
        .ht-dialog-content {
            top: 50%
            opacity: 1
            background: none !important
            box-shadow: none
            text-align: center
            label {
                display: block
                margin-top: 0.2rem
                color: #fff
                font-size: 0.16rem
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue